<script>
	import { Flag, Landmark, UtensilsCrossed, Laugh } from 'lucide-svelte';
	import introImage from '$lib/assets/enhanced/legends-golf.jpg?enhanced';

	const pillars = [
		{ icon: Flag, label: 'World-class golf' },
		{ icon: Landmark, label: 'Rich Tasmanian history' },
		{ icon: UtensilsCrossed, label: 'Food & drink' },
		{ icon: Laugh, label: 'Great stories' }
	];
</script>

<section class="bg-white pb-16 pt-16 lg:pb-24 lg:pt-24">
	<div class="mx-auto max-w-7xl px-4">
		<div class="mx-auto max-w-3xl text-center">
			<p class="text-sm font-semibold uppercase tracking-widest text-[#194139]">
				The signature Tassie Tours journey
			</p>
			<h2 class="mt-3 font-heading text-3xl font-semibold tracking-tight sm:text-4xl">
				A premium small-group golf journey through Tasmania's most iconic places
			</h2>
			<p class="mt-6 leading-7 text-gray-700 lg:text-lg">
				Legends of Tasmania is a premium 4-day, 4-night small-group golf journey through some of
				Tasmania's most iconic courses and unforgettable places.
			</p>
			<p class="mt-4 leading-7 text-gray-700 lg:text-lg">
				Play two top 10 courses, Australia's oldest course, and be among the first on Tasmania's
				newest courses. Barnbougle - Lost Farm, Ratho Farm, Championship Golf Course Launceston and
				7 Mile Beach, while travelling through historic villages, legendary country pubs, heritage
				sites, breweries and some of Tasmania's best food and drink experiences.
			</p>
		</div>

		<ul class="mx-auto mt-10 flex max-w-4xl flex-wrap items-center justify-center gap-3">
			{#each pillars as pillar}
				<li
					class="flex items-center gap-2 rounded-full border border-[#194139]/20 bg-[#194139]/5 px-5 py-2 text-sm font-medium text-[#194139]"
				>
					<pillar.icon class="h-4 w-4" />
					{pillar.label}
				</li>
			{/each}
		</ul>

		<!-- The "it's not only the golf" beat, given its own weight. -->
		<div class="mt-16 grid grid-cols-1 items-center gap-x-12 gap-y-10 lg:mt-24 lg:grid-cols-2">
			<div class="relative overflow-hidden rounded-3xl shadow-xl">
				<enhanced:img
					src={introImage}
					alt="A links green framed by coastal dunes on a Tasmanian golf course"
					class="aspect-[4/3] h-full w-full object-cover"
					sizes="(min-width: 1024px) 50vw, 100vw"
					loading="lazy"
				/>
			</div>
			<div>
				<p class="font-heading text-2xl font-bold leading-snug sm:text-3xl">
					But this isn't just about the golf.
				</p>
				<hr class="my-6 w-16 border-2 border-tt-red" />
				<p class="leading-7 text-gray-700 lg:text-lg">
					Your passionate local guide brings Tasmania's history to life with stories, characters and
					plenty of humour — and can also hit a ball!
				</p>
			</div>
		</div>
	</div>
</section>
